const specs = {
    62:   { name: "arcane",         type: "range", main: "int", role: "Damage" },
    63:   { name: "fire",           type: "range", main: "int", role: "Damage" },
    64:   { name: "frost",          type: "range", main: "int", role: "Damage" },
    65:   { name: "holy",           type: "range", main: "int", role: "Heal"   },
    66:   { name: "protection",     type: "melee", main: "str", role: "Tank"   },
    70:   { name: "retribution",    type: "melee", main: "str", role: "Damage" },
    71:   { name: "arms",           type: "melee", main: "str", role: "Damage" },
    72:   { name: "fury",           type: "melee", main: "str", role: "Damage" },
    73:   { name: "protection",     type: "melee", main: "str", role: "Tank"   },
    102:  { name: "balance",        type: "range", main: "int", role: "Damage" },
    103:  { name: "feral",          type: "melee", main: "agi", role: "Damage" },
    104:  { name: "guardian",       type: "melee", main: "agi", role: "Tank"   },
    105:  { name: "restoration",    type: "Heal",  main: "int", role: "Heal"   },
    250:  { name: "blood",          type: "melee", main: "str", role: "Tank"   },
    251:  { name: "frost",          type: "melee", main: "str", role: "Damage" },
    252:  { name: "unholy",         type: "melee", main: "str", role: "Damage" },
    253:  { name: "beast mastery",  type: "range", main: "agi", role: "Damage" },
    254:  { name: "marksmanship",   type: "range", main: "agi", role: "Damage" },
    255:  { name: "survival",       type: "range", main: "agi", role: "Damage" },
    256:  { name: "discipline",     type: "Heal",  main: "int", role: "Heal"   },
    257:  { name: "holy",           type: "Heal",  main: "int", role: "Heal"   },
    258:  { name: "shadow",         type: "range", main: "int", role: "Damage" },
    259:  { name: "assassination",  type: "melee", main: "agi", role: "Damage" },
    260:  { name: "outlaw",         type: "melee", main: "agi", role: "Damage" },
    261:  { name: "subtlety",       type: "melee", main: "agi", role: "Damage" },
    262:  { name: "elemental",      type: "range", main: "int", role: "Damage" },
    263:  { name: "enhancement",    type: "melee", main: "agi", role: "Damage" },
    264:  { name: "restoration",    type: "Heal",  main: "int", role: "Heal"   },
    265:  { name: "affliction",     type: "range", main: "int", role: "Damage" },
    266:  { name: "demonology",     type: "range", main: "int", role: "Damage" },
    267:  { name: "destruction",    type: "range", main: "int", role: "Damage" },
    268:  { name: "brewmaster",     type: "melee", main: "agi", role: "Tank"   },
    269:  { name: "windwalker",     type: "melee", main: "agi", role: "Damage" },
    270:  { name: "mistweaver",     type: "Heal",  main: "int", role: "Heal"   },
    577:  { name: "havoc",          type: "melee", main: "agi", role: "Damage" },
    581:  { name: "vengeance",      type: "melee", main: "agi", role: "Tank"   },
    1467: { name: "devastation",    type: "range", main: "int", role: "Damage" },
    1468: { name: "preservation",   type: "Heal",  main: "int", role: "Heal"   },
    1473: { name: "augmentation",   type: "range", main: "int", role: "Damage" },
    1480: { name: "devourer",       type: "range", main: "int", role: "Damage" }
};


class ClassUtility {
    resolveStatsForSpecType(character) {
        let specId = character.details.activeSpec.id;

        if(specs[specId]){
            let type = specs[specId].type;

            character.details.stats.main = specs[specId].main;
            if(type === "melee"){
                character.details.stats.haste = character.details.stats.melee_haste;
                character.details.stats.crit = character.details.stats.melee_crit;
            } else {
                character.details.stats.haste = character.details.stats.spell_haste;
                character.details.stats.crit = character.details.stats.spell_crit;
            }
        } else {
            character.details.stats.main = 0;
            character.details.stats.haste = 0;
            character.details.stats.haste = 0;
        }
    }

    getRoleForSpec(spec) {
        return Object.values(specs).find(s => s.name === spec)?.role;
    }

    getMainStatForSpec(spec) {
        return Object.values(specs).find(s => s.name === spec)?.main;
    }
}

export default new ClassUtility();
